import { PostProperties } from "../types";
import image from "../img/lostGemConforce.jpg";

const post: PostProperties = {
  id: 40,
  title: "Conforce - Linke Soto, Maastricht, Netherlands (27.04.2013)",
  content: `Conforce, also known as Versalife or Boris Bunnik, a producer and DJ from Terschelling, Netherlands. Conforce is known for a unique style that blends multiple genres to create remarkable music.
This scarcely found mix gives you a taste of his distinct sound and his ability to tell a story. `,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/conforce-linke-soto-maastricht-netherlands-27042013",
  category: "Lost Gem",
  translationsBg: {
    content: `Conforce, известен още като Versalife или Boris Bunnik, е продуцент и DJ от Терсхелинг, Холандия. Conforce е известен с уникалния си стил, който съчетава множество жанрове, за да създаде забележителна музика.
Тази рядко срещана смесица ви дава представа за неговия отличителен звук и способността му да разказва истории.`,
  },
};

export default post;
